// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"30":"266ea843","121":"5baf410a","424":"e9d90877","457":"ad9700fc","568":"2feb8546","591":"a2e84e5f","764":"33bcfd23","885":"1c83e772","989":"f2dc23a9"}[chunkId] + ".js";
};